import { http } from './http'

/**
 * 图片上传
 * @param data
 * @returns
 */
export const apiUploadImage = (data: {
  input_file?: File
  photo_url?: string
}) => {
  return http.post<any>(
    '/api/file/upload',
    { data },
    {
      timeout: 300000,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

/**
 * 图片分割
 * @param data
 * @returns
 */
export const apiSegmentImage = (data: { photo: File }) => {
  return http.post<any>(
    '/api/ad_fashion/segment/rgba',
    { data },
    {
      timeout: 300000,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

/**
 * 图片编辑
 * @param data
 * @returns
 */
export const apiEditImage = (data: { photo_base64: string }) => {
  return http.post<any>('/api/ad_fashion/edit/image', { data })
}

/**
 * 图片描述
 * @param data
 * @returns
 */
export const apiImageDescription = (data: { image_url: string }) => {
  return http.post<any>('/api/ad_fashion/image/to/desc', { data })
}

/**
 * 推荐参考图片列表
 * @param data
 */
export const apiImageReferenceList = (data: {
  image_description: string
  page: number
  page_size: number
}) => {
  return http.post<any>('/api/ad_fashion/recommend/image', { data })
}

/**
 * 创建任务
 * @param data
 * task_type:
 * - auto_image_create
 * - reference_image_create
 * - message_image_create
 * - object_retouch
 * - image2video
 * @returns
 */
export const apiCreateTask = (data: {
  task_type: string
  product_image_id?: string
  product_mask_id?: string
  reference_image_id?: string
  input_images_ids?: string[]
  message?: string
  generate_mode?: string
  number?: number
  aspect_ratio?: string
  extra_args?: object
}) => {
  return http.post<any>('/api/aitask/create', { data })
}

export const apiTaskList = (data: { page: number; page_size: number }) => {
  return http.post<any>('/api/aitask/list', { data })
}

/**
 * 任务详情，返回任务生成的照片列表和视频列表
 * @param task_id
 * @returns
 */
export const apiTaskDetail = (task_id: string) => {
  return http.get<any>('/api/aitask/details/' + task_id)
}

/**
 * 任务状态
 * @param task_id
 * @returns
 */
export const apiTaskStatus = (task_id: string) => {
  return http.get<any>('/api/aitask/status/' + task_id)
}
